<div class="container-sm">
  @if (filters$ | async; as filters) {
    <!-- Only show filters, if there is more than one -->
    @if (filters.length > 1) {
      <!-- mobile filters -->
      <mb-dropdown
        [options]="filters"
        class="contain"
        [class.display-inline-flex]="collapseOnDesktop"
        [hideLabel]="false"
        [class.active]="activeFilter$.value !== 'all'"
        (selectionChanged)="setFilter($event.value)"
      ></mb-dropdown>
      <!-- tabbed filters -->
      <ul class="tab-navigation copy-l" [class.hide]="collapseOnDesktop">
        @for (filter of filters; track filter.value) {
          <li
            class="tab-navigation-item"
            [class.active]="activeFilter$.value === filter.value"
            (click)="setFilter(filter.value)"
          >
            {{ filter.label | translate }}
          </li>
        }
      </ul>
    }
  }
</div>

@if (presenters$ | async; as presenter) {
  <div class="container-sm collapse-sm">
    <div class="card-list">
      @for (expert of presenter; track expert.id) {
        <mb-contact-person-card
          class="column-card col-12 col-lg-6"
          [fullname]="expert.fullname"
          [position]="expert.position"
          [media]="expert.image"
          [initials]="expert.initials"
          [topline]="expert.availabilityPeriod"
          [hideMedia]="false"
        ></mb-contact-person-card>
      }
    </div>
  </div>
}
